import React from 'react';
import { INSTAGRAM_LINK, SUPPORT_EMAIL, WEB_LINK, WHATSAPP_LINK } from './Shared';
export function Footer() {
  return <>
      <section className="border-t-2 border-brand-gold/50 bg-brand-parchment py-12" aria-labelledby="ps-title" data-id="element-104" data-mp="3ggtzeln15p6t">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-105" data-mp="32pp601a99t4x">
          <h2 id="ps-title" className="font-serif text-xl font-bold text-brand-taupe" data-id="element-106" data-mp="36qhh702ou83u">
            P.D.: Si tenés dudas, escribinos.
          </h2>
          <ul className="mt-4 space-y-2 text-sm text-brand-textLight md:text-base" data-id="element-107" data-mp="3ud7h9vvh7slt">
            <li data-id="element-108" data-mp="37xuse6oxwgy">
              📧 <strong className="text-brand-taupe" data-id="element-109" data-mp="3lecaahklyehg">Email:</strong>{' '}
              <a className="font-semibold text-brand-goldDark hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-110" data-mp="3le2jirrqo3ap">
                {SUPPORT_EMAIL}
              </a>
            </li>
            <li data-id="element-111" data-mp="29ydw5zakp29d">
              📲 <strong className="text-brand-taupe" data-id="element-112" data-mp="29xvrqfdrbhqd">Instagram:</strong>{' '}
              <a className="font-semibold text-brand-goldDark hover:underline" href={INSTAGRAM_LINK} data-id="element-113" data-mp="2ez1kgd7f34zw">
                @lumen.akasha
              </a>
            </li>
            <li data-id="element-114" data-mp="3gapcti26iifg">
              💬 <strong className="text-brand-taupe" data-id="element-115" data-mp="3gb8s0r0g2sps">WhatsApp:</strong>{' '}
              <a className="font-semibold text-brand-goldDark hover:underline" href={WHATSAPP_LINK} data-id="element-116" data-mp="3v7gg42ez4eac">
                Escribinos ahora
              </a>
            </li>
            <li data-id="element-117" data-mp="3qapz9cvchenv">
              🌐 <strong className="text-brand-taupe" data-id="element-118" data-mp="830hxf7jlyyw">Web:</strong>{' '}
              <a className="font-semibold text-brand-goldDark hover:underline" href={WEB_LINK} data-id="element-119" data-mp="817d85ghpotj">
                www.lumenakasha.com
              </a>
            </li>
          </ul>
          <p className="mt-5 text-sm italic text-brand-muted" data-id="element-120" data-mp="hrihjt43600y">
            Te respondemos hoy. Sin demoras. Sin automatizaciones.
          </p>
        </div>
      </section>

      <footer className="bg-brand-text py-12 text-center font-sans text-white" data-id="element-121" data-mp="qsqd43f7wmrc">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-122" data-mp="ms6fyzun9j57">
          <p className="mb-3 font-serif text-2xl font-bold text-brand-gold md:text-3xl" data-id="element-123" data-mp="mtr86ithkpzw">🌿 LUMEN AKASHA™</p>
          <p className="text-sm text-white/85 md:text-base" data-id="element-124" data-mp="tt0ayvxa0wt4">
            El sistema definitivo de Cosmética Natural como Negocio de Vida.
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 text-sm md:flex-row md:gap-7" data-id="element-125" data-mp="13s9a037011mc">
            <a className="transition-colors duration-150 ease-out hover:text-brand-gold" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-126" data-mp="18ksmewty9qpk">
              📧 {SUPPORT_EMAIL}
            </a>
            <a className="transition-colors duration-150 ease-out hover:text-brand-gold" href={INSTAGRAM_LINK} data-id="element-127" data-mp="1hk5wnrpwejbc">
              📲 @lumen.akasha
            </a>
            <a className="transition-colors duration-150 ease-out hover:text-brand-gold" href={WEB_LINK} data-id="element-128" data-mp="1mhpaiqioou2r">
              🌐 www.lumenakasha.com
            </a>
          </div>

          <div className="mt-10 space-y-2 border-t border-white/20 pt-6 text-xs text-white/55" data-id="element-129" data-mp="3ocpy1jok63yr">
            <p data-id="element-130" data-mp="3tarst1vcjrq2">© Lumen Akasha™ 2025 — Todos los derechos reservados.</p>
            <p data-id="element-131" data-mp="2afdhlagc14nq">Prohibida la reproducción y redistribución sin autorización expresa.</p>
            <p data-id="element-132" data-mp="25nvikrxvde5e">Ley 25.326 — Protección de Datos Personales — República Argentina</p>
            <p data-id="element-133" data-mp="21mti67s7uw1u">Ley 11.723 — Propiedad Intelectual — República Argentina</p>
          </div>
        </div>
      </footer>
    </>;
}